let apiHost: string;
let chatHost: string;
let googleKey: string;
let documentHost: string;
let documentFrontendHost: string;

const hostname = window && window.location && window.location.hostname;
// Production
if (hostname === "app.simflexity.com") {
  apiHost = "https://api.simflexity.com";
  chatHost = "https://gigleerbackendchat-prod.azurewebsites.net";
  googleKey = "AIzaSyDTqnnV670j9pWZw9wEku5VKtCjVcUVdg0";
  documentHost =
    "https://simflexity-prod-contracts-b5bbaeg5h3gwb4de.swedencentral-01.azurewebsites.net";
  documentFrontendHost =
    "https://simflexity-prod-contracts-b5bbaeg5h3gwb4de.swedencentral-01.azurewebsites.net";
}
// Staging
else if (hostname === "app-stage.simflexity.com") {
  apiHost = "https://api-stage.simflexity.com";
  chatHost = "https://gigleerbackendchat-staging.azurewebsites.net";
  googleKey = "AIzaSyDMXv1Ni1Pk3sbFsa6W3bfraVY8rkmRrbY";
  documentHost =
    "https://simflexity-stage-contracts-a4hbb9aje0cxfxaw.swedencentral-01.azurewebsites.net";
  documentFrontendHost =
    "https://simflexity-stage-contracts-a4hbb9aje0cxfxaw.swedencentral-01.azurewebsites.net";
}
// Dev
else {
  apiHost = "https://api-dev.simflexity.com";
  chatHost = "https://gigleerbackendchat-dev.azurewebsites.net";
  googleKey = "AIzaSyD1DJ5GAYQrcNYlkPtGtAClz_-6PByXwAQ";
  // documentHost = "https://document-api-dev.simflexity.com";
  documentHost =
    "https://simflexity-dev-contracts-dxfxf0h4hthta3dn.swedencentral-01.azurewebsites.net";
  documentFrontendHost =
    "https://simflexity-dev-contracts-dxfxf0h4hthta3dn.swedencentral-01.azurewebsites.net";
}

export const API_ROOT = `${apiHost}/api`;
export const DOCUMENT_API_ROOT = `${documentHost}/api/v1/document`;
export const DOCUMENT_FRONTEND_ROOT = documentFrontendHost;
export const CHAT_ROOT = chatHost;
export const GOOGLE_KEY = googleKey;
